import map from "lodash/map";
import fromPairs from "lodash/fromPairs";
import { camelize, humanize, titleize, underscored } from "underscore.string";

const trackingTypes = [
  "answerViewed",
  "answerViewedComplete",
  "bitrateReported",
  "browserNavigation",
  "chapterButton",
  "chapterResumed",
  "chapterViewed",
  "chapterViewedComplete",
  "cuepointClick",
  "hotspotClick",
  "hotspotOffered",
  "linkConverted",
  "linkOffered",
  "mediaProgress", // This with startTime:0 effectively means 'chapter played'
  "playOrPause",
  "qaScroll",
  "qaSubmenu",
  "quartile",
  "returnToParentChapter",
  "scrub",
  "singleVideoLoaded",
  "singleVideoViewed",
  "slideViewed",
  "slideViewedComplete",
  "storyInfoChapterClick",
  "storyListViewed",
  // "storyLoaded", // TODO implement
  "storyPreviewClick",
  "storyTitleClick",
  "storyViewed", // This means 'loaded,' but not 'played'
  "timelineViewed",
];

let types = map(trackingTypes, (key) => humanize(underscored(key)));
types = map(types, (key) => [camelize(underscored(key)), titleize(key)]);
types = fromPairs(types);

export default {
  ...types,
  uiInteracted: "UI Interacted",
};
